import React, { useEffect, useRef, useState } from 'react';
import { Box, Grid, useMediaQuery } from '@mui/material';
import Section from '../../../shared/Section/Section';
import DetailsItem from './DetailsItem';

const splitArray = (arr) => {
  const middle = Math.ceil(arr.length / 2);
  const firstHalf = arr.slice(0, middle);
  const secondHalf = arr.slice(middle);
  return [firstHalf, secondHalf];
};

function NewDetails({ details, title, subtitle, bg }) {
  const isAboveMd = useMediaQuery((theme) => theme.breakpoints.up('md'));
  const isBelowLg = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const [isMediaQueryReady, setIsMediaQueryReady] = useState(false);
  useEffect(() => {
    if (!isMediaQueryReady && (isAboveMd || isBelowLg)) {
      setIsMediaQueryReady(true);
    }
  }, [isAboveMd, isBelowLg]);

  const listRefs = useRef([]);

  useEffect(() => {
    setTimeout(() => {
      if (isMediaQueryReady) {
        listRefs.current.forEach((item) => {
          const textHeight = item && item.querySelector('.text').offsetHeight;
          const iconHeight = item && item.querySelector('.icon').offsetHeight;
          if (item) {
            if (textHeight > iconHeight) {
              item.style.alignItems = 'flex-start';
            } else {
              item.style.alignItems = 'center';
            }
          }
        });
      }
    }, 50);
  }, [details, isMediaQueryReady]);

  return (
    <Section title={title} subtitle={subtitle} bg={bg} withoutBg={!bg}>
      <Box sx={{ width: { xs: '100%', md: 900, lg: 1150 } }}>
        <Grid
          container
          columnSpacing={2}
          sx={{
            '& > :not(:first-of-type)': { mt: { xs: 3, lg: 0 } },
          }}
        >
          <Grid item xs={10} md={6}>
            {splitArray(details)[0].map((detail, index) => (
              <DetailsItem
                key={detail.title}
                ref={(el) => (listRefs.current[index] = el)}
                detail={detail}
              />
            ))}
          </Grid>
          <Grid item xs={10} md={6}>
            {splitArray(details)[1].map((detail, index) => (
              <Box key={detail.title} sx={{ width: { xs: '100%', lg: 350 } }}>
                <DetailsItem
                  ref={(el) => (listRefs.current[index] = el)}
                  detail={detail}
                />
              </Box>
            ))}
          </Grid>
        </Grid>
      </Box>
    </Section>
  );
}

export default NewDetails;
